module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAA8CAYAAABmdppWAAABN0lEQVRYhe3YMWoCQRTG8f9qrmAhsUubQwRBO20trGz3BoE0OUVasbUSuxRiYeNNAnaCWAhJGHY2iOw482ZeoWRfsyPij/e9HZfdzR4Hbz9U1wSYOr5z1gOZ9CdeUFfU7zBrqHd465FRj6wNKo/wHiLrz7Ch6v3TGdaRU0GadeRk8Pa3TR05GdSPrN3hHVwP0yK37HH3ByZENtjKrrslGhu5xJ7tZ7PuAV8xkS8x7HoDvEgjV2FlPQELSeRrmKk9kIeCIVgf2IaAbeAzBCPg7qsDrO18vBiejS3G8OzDd8DVfyVGcdPuBMWYr0MxJgW9mAX1sNAOgzE8J0WM+ToUY1x5vD3EYK4Oj8AwBqvq8ASMzi7tcvDspHwDY2AZi112aF78zFOwAixmmAOzVMyU+Z+8Ah8aGMAvcto4qaTgVxEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/dynamicsJT.png
// module id = ihXN
// module chunks = 0